import { Component, OnInit } from '@angular/core';
import { ToastMessage, ToastService } from '../../../core/services/toast.service';
import { MatIcon } from "@angular/material/icon";
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class ToastComponent implements OnInit {
  toast: ToastMessage | null = null;
  private timeoutId: any;

  constructor(private toastService: ToastService) { }

  ngOnInit() {
    this.toastService.toastState$.subscribe((toast) => {
      this.toast = toast;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => this.closeToast(), toast.duration || 3000);
    });
  }

  closeToast() {
  // console.log('Toast closed');
  this.toast = null;
  clearTimeout(this.timeoutId);
  }
}
